var ImagesLoaded = require("imagesloaded");
var jQueryBridget = require("jquery-bridget");
var Masonry = require("masonry-layout");

jQueryBridget("masonry", Masonry, $);
jQueryBridget("imagesLoaded", ImagesLoaded, $);

$(document).ready(function() {
  // Owl Carousels
  $(".owl-one").imagesLoaded(function() {
    $(".owl-one").owlCarousel({
      items: 12,
      loop: true,
      margin: 0,
      merge: true,
      navSpeed: 300,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      autoplay : true,
      autoplaySpeed: 500,
      autoplayTimeout: 7000,
      navigation: true,
      dots: false,
      navText: ["",""],
      addClassActive: true,
      responsive: {
        0: {
          merge: false,
          items: 1
        },
        678: {
          mergeFit: true
        },
        1000: {
          mergeFit: true
        }
      }
    });
    // hide owl nav when only one slide
    let slides = $('.owl-item:not(.cloned)').length;
    if (slides == 1) $('.owl-nav').hide();
  });

  $(".owl-two").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    navText: ["", ""],
    addClassActive: true,
    center: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 3
      }
    }
  });

  $(".owl-three").imagesLoaded(function() {
    $(".owl-three").owlCarousel({
      items: 1,
      loop: true,
      navText: [
        "<i class='fal fa-arrow-left'></i>",
        "<i class='fal fa-arrow-right'></i>"
      ],
      smartSpeed: 900,
      singleItem: true,
      responsive: {
        0: {
          dots: true,
          nav: false,
          stagePadding: 0
        },
        768: {
          dots: false,
          nav: true,
          stagePadding: 100,
          margin: 30
        }
      }
    });
  });

  $(".owl-four").imagesLoaded(function() {
    $(".owl-four").owlCarousel({
      items: 1,
      loop: true,
      navText: [
        "<i class='fal fa-arrow-left'></i>",
        "<i class='fal fa-arrow-right'></i>"
      ],
      smartSpeed: 900,
      singleItem: true,
      responsive: {
        0: {
          dots: false,
          nav: true,
          autoplay : true,
          margin: 50
        },
        768: {
          dots: false,
          nav: true,
        }
      }
    });
  });
  

  $(".owl-three-single").imagesLoaded(function() {
    $(".owl-three-single").owlCarousel({
      items: 1,
      loop: false,
      dots: false,
      nav: false,
      singleItem: true
    });
  });

  $(".intro-owl-carousel").owlCarousel({
    singleItem: true,
    nav: false,
    dots: true,
    items: 1,
    itemsDesktop: false,
    itemsDesktopSmall: false,
    itemsTablet: false,
    itemsMobile: false
  });

  setTimeout(function() {
    if ($("div.owl-item:not(.cloned)").length == 1) {
      $("div.owl-dots button").hide();
    }
  }, 10);

  // Masonry Layout
  var $grid = $(".grid");
  $grid.imagesLoaded(function() {
    $grid.masonry({
      itemSelector: ".grid-item",
      columnWidth: ".grid-item",
      gutter: 20,
      horizontalOrder: true
    });
  });

  $("img.lazy").lazyload();

});


// WEBPACK FOOTER //
// ./source/assets/js/modules/layout.js